export default __webpack_public_path__ + "static/media/claims.69c63f8b.svg";